// import React from 'react';

// const features = [
//   { title: 'Personalized Approach', desc: 'Tailored programs for individual needs.' },
//   { title: 'Expert Mentors', desc: 'Guidance from experienced professionals.' },
//   { title: 'Comprehensive Coverage', desc: 'Support from school to professional level.' }
// ];

// const WhyChooseUs = () => (
//   <section id="why" className="bg-white py-16">
//     <div className="text-center mb-12">
//       <h2 className="text-3xl font-bold text-blue-800">Why Choose Us?</h2>
//     </div>
//     <div className="flex flex-wrap justify-center gap-6 px-6">
//       {features.map(({ title, desc }) => (
//         <div key={title} className="w-full md:w-1/3 p-6 bg-blue-50 rounded-lg shadow">
//           <h3 className="text-xl font-semibold text-blue-700 mb-2">{title}</h3>
//           <p className="text-gray-700">{desc}</p>
//         </div>
//       ))}
//     </div>
//   </section>
// );

// export default WhyChooseUs;
import React from "react";
import { FaUserGraduate, FaRocket, FaGlobeAmericas } from "react-icons/fa";
import ParticleBackground from "../backgrounds/ParticleBackground";

const features = [
  { 
    title: "Personalized Approach", 
    desc: "Tailored programs that cater to individual needs and aspirations.", 
    icon: <FaUserGraduate className="text-4xl text-purple-500 group-hover:scale-125 transition-transform" /> 
  },
  { 
    title: "Expert Mentors", 
    desc: "Access to experienced professionals and industry experts who guide your journey.", 
    icon: <FaRocket className="text-4xl text-pink-500 group-hover:scale-125 transition-transform" /> 
  },
  { 
    title: "Comprehensive Coverage", 
    desc: "Support from schooling to professional life, ensuring continuous growth and development.", 
    icon: <FaGlobeAmericas className="text-4xl text-blue-500 group-hover:scale-125 transition-transform" /> 
  },
  { 
    title: "Proven Success", 
    desc: "A track record of helping individuals and organizations achieve their full potential.", 
    icon: <FaUserGraduate className="text-4xl text-green-500 group-hover:scale-125 transition-transform" /> 
  }
];

const WhyChooseUs = () => (
  <section id="why" className="relative py-20 bg-gradient-to-br from-pink-100 via-white to-blue-100 overflow-hidden">
    {/* Subtle glowing orbs background */}
    <ParticleBackground />
    <div className="absolute top-10 left-10 w-32 h-32 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
    <div className="absolute bottom-10 right-20 w-40 h-40 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-bounce"></div>

    <div className="relative text-center mb-12">
      <h2 className="text-4xl md:text-5xl font-extrabold text-gray-800 drop-shadow-md">
        Why Choose <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500">Us?</span>
      </h2>
      <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
        Right decisions at the right time — don't leave your career to chance.
      </p>
      <div className="mt-4 flex flex-wrap justify-center gap-3 text-sm font-medium text-gray-500">
        <span className="bg-white/80 px-4 py-1.5 rounded-full shadow">⚠️ Fear of wrong decision?</span>
        <span className="bg-white/80 px-4 py-1.5 rounded-full shadow">⏰ Early planning matters</span>
        <span className="bg-white/80 px-4 py-1.5 rounded-full shadow">🎯 Avoid real-life consequences</span>
      </div>
    </div>

    <div className="relative flex flex-wrap justify-center gap-8 px-6">
      {features.map(({ title, desc, icon }) => (
        <div 
          key={title} 
          className="group w-full sm:w-[300px] p-8 rounded-2xl shadow-xl bg-white/70 backdrop-blur-md border border-white hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer"
        >
          <div className="mb-4 flex justify-center">{icon}</div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">{title}</h3>
          <p className="text-gray-600 text-sm">{desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default WhyChooseUs;
